import axios from 'axios';
import '../Sys/config.js';

const apiUrl = global.platformURI;

// An uncached insights build takes 40–70 seconds on staging.
export const INSIGHTS_TIMEOUT_MS = 120000;
const LATEST_SIGN_INS_TIMEOUT_MS = 30000;

const filenameFromDisposition = disposition => {
  const match = /filename\*?=(?:UTF-8'')?"?([^";]+)"?/i.exec(disposition || '');
  return match ? decodeURIComponent(match[1]) : undefined;
};

const downloadXlsx = (url, params) => axios
  .get(url, { params, responseType: 'blob', timeout: INSIGHTS_TIMEOUT_MS })
  .then(res => ({
    blob: res.data,
    filename: filenameFromDisposition(res.headers?.['content-disposition']),
  }));

export class Dashboard {
    constructor() {
        axios.interceptors.request.use(
          function (config) {
            let token = localStorage.getItem('ssoToken');
            config.baseURL = apiUrl;
            config.headers.Authorization = `Token ${token}`;
            return config;
          },
          error => {
            console.log('error.response.status', error);
            return error;
          }
        );
    }

    getDetailDashboardCustomer() {
        return axios.get('main/customeradmindashboard')
            .then(res => res.data);
    }
    getDetailDashboardSuperAdmin() {
        return axios.get('main/superadmindashboard')
            .then(res => res.data);
    }
    getDetailDashboardUser() {
        return axios.get('main/userdashboard')
            .then(res => res.data);
    }
    getPopularCourseGraph() {
      return axios.get('main/popularcoursegraph')
          .then(res => res.data);
    }
    getTopCustomerAndUsers() {
      return axios.get('main/customerlistwithlicensecount')
          .then(res => res.data);
    }

    /**
     * Load the complete Superadmin command-centre payload.
     *
     * @param {'7d'|'30d'|'90d'|'365d'} period
     * @param {boolean} refresh when true, bypasses the server's five-minute cache
     * @returns {Promise<{status: boolean, message: string, data: import('../Pages/DashBoard/SuperadminInsights/types').SuperadminInsightsData}>}
     */
    getSuperadminInsights(period = '30d', refresh = false) {
      return axios.get('main/superadmin_insights', {
        params: {
          period,
          ...(refresh ? { refresh: true } : {})
        },
        timeout: INSIGHTS_TIMEOUT_MS
      }).then(res => res.data);
    }

    getSuperadminLatestSignIns(limit = 10) {
      return axios.get('main/superadmin_insights/latest_sign_ins', {
        params: { limit },
        timeout: LATEST_SIGN_INS_TIMEOUT_MS
      }).then(res => res.data);
    }

    getSuperadminCustomerInsights(customerId, refresh = false) {
      return axios.get(`main/superadmin_insights/customers/${encodeURIComponent(customerId)}`, {
        ...(refresh ? { params: { refresh: true } } : {}),
        timeout: INSIGHTS_TIMEOUT_MS
      }).then(res => res.data);
    }

    getSuperadminProjects(params = {}) {
      return axios.get('main/superadmin_insights/projects', {
        params,
        timeout: INSIGHTS_TIMEOUT_MS
      }).then(res => res.data);
    }

    getSuperadminProjectInsights(projectId, refresh = false) {
      return axios.get(`main/superadmin_insights/projects/${encodeURIComponent(projectId)}`, {
        ...(refresh ? { params: { refresh: true } } : {}),
        timeout: INSIGHTS_TIMEOUT_MS
      }).then(res => res.data);
    }

    exportSuperadminInsights(period = '30d', section = 'all') {
      return downloadXlsx('main/superadmin_insights/export', { period, section });
    }

    exportSuperadminCustomerInsights(customerId) {
      return downloadXlsx(
        `main/superadmin_insights/customers/${encodeURIComponent(customerId)}`,
        { format: 'xlsx' }
      );
    }

    exportSuperadminProjectInsights(projectId) {
      return downloadXlsx(
        `main/superadmin_insights/projects/${encodeURIComponent(projectId)}`,
        { format: 'xlsx' }
      );
    }

    getCourseRequestsPage(page = 1) {
      return axios.get('main/courserequest/', { params: { page } })
        .then(res => res.data);
    }
}
